<div class="financial-statement-import-definition-container">
    <h3>{{ title }}</h3>

    <div class="import-definition-form-container">
        <form [formGroup]="form">
            <div
                class="field"
                [ngClass]="{ 'active-field': activeField === fieldsEnum.sheetName }"
                #sheetName
                (click)="setActiveField(fieldsEnum.sheetName)"
            >
                <aum-select
                    placeholder="{{ 'aumico_annual_report_import_please_select' | i18next }}"
                    [aumFormControl]="form.controls['sheetName']"
                    [options]="sheetNameOptions"
                >
                    <aum-form-field-label>
                        {{ 'aumico_annual_report_import_definition_which_spreadsheet_1' | i18next }}
                        {{ title }}
                        {{ 'aumico_annual_report_import_definition_which_spreadsheet_2' | i18next }}
                    </aum-form-field-label>
                </aum-select>
                <div class="click-cell-button" *ngIf="fieldsEnum.sheetName === activeField">
                    <button aum-icon-button color="accent" icon="lighting-light-bulb">
                        {{ 'aumico_annual_report_import_definition_click_corresponding_sheet' | i18next }}
                    </button>
                </div>
            </div>

            <div class="copy-definition-container" *ngIf="copiedDefinition && showTransferEntries">
                <button
                    class="transfer-entries-button"
                    aum-icon-button
                    color="accent"
                    icon="lighting-light-bulb"
                    (click)="transferEntries()"
                    [disabled]="sheetNameFirstTime"
                >
                    {{ 'aumico_annual_report_import_definition_transfer_entries' | i18next }} {{ title }}
                </button>
                <button
                    class="fill-manually-button"
                    aum-icon-button
                    color="basic"
                    icon="edit-write"
                    disableRipple
                    (click)="fillManually()"
                >
                    {{ 'aumico_annual_report_import_definition_fill_manually' | i18next }} {{ title }}
                </button>
            </div>

            <div
                class="field"
                [ngClass]="{ 'active-field': activeField === fieldsEnum.accountsStartingRow }"
                #titleRow
                *ngIf="!sheetNameFirstTime && showForm"
                (click)="setActiveField(fieldsEnum.accountsStartingRow)"
            >
                <aumico-number-input
                    class="account-start-row"
                    [decimalPlaces]="0"
                    [allowNegative]="false"
                    [control]="form.controls['accountsStartingRow']"
                >
                    <aum-form-field-label>
                        {{
                            'aumico_annual_report_import_definition_specify_data_start_line_1' | i18next
                        }}</aum-form-field-label
                    >
                </aumico-number-input>
                <div class="click-cell-button" *ngIf="fieldsEnum.accountsStartingRow === activeField">
                    <button aum-icon-button color="accent" icon="lighting-light-bulb">
                        {{ 'aumico_annual_report_import_definition_click_cell' | i18next }}
                    </button>
                </div>
            </div>
            <div
                class="field"
                [ngClass]="{ 'active-field': activeField === fieldsEnum.accountNo }"
                #accountNo
                *ngIf="!accountsStartingRowFirstTime && showForm"
                (click)="setActiveField(fieldsEnum.accountNo)"
            >
                <aum-select
                    placeholder="{{ 'aumico_annual_report_import_please_select' | i18next }}"
                    [aumFormControl]="form.controls['accountNoCol']"
                    [options]="columnOptions"
                >
                    <aum-form-field-label
                        >{{ 'aumico_annual_report_import_indicate_account_numbers_column' | i18next }}
                    </aum-form-field-label>
                </aum-select>
                <div class="click-cell-button" *ngIf="activeField === fieldsEnum.accountNo">
                    <button aum-icon-button color="accent" icon="lighting-light-bulb">
                        {{ 'aumico_annual_report_import_definition_click_cell' | i18next }}
                    </button>
                </div>
            </div>
            <div
                class="field"
                [ngClass]="{ 'active-field': activeField === fieldsEnum.accountName }"
                #accountName
                *ngIf="!accountNoFirstTime && showForm"
                (click)="setActiveField(fieldsEnum.accountName)"
            >
                <aum-select
                    placeholder="{{ 'aumico_annual_report_import_please_select' | i18next }}"
                    [aumFormControl]="form.controls['accountNameCol']"
                    [options]="columnOptions"
                >
                    <aum-form-field-label
                        >{{ 'aumico_annual_report_import_indicate_account_names_column' | i18next }}
                    </aum-form-field-label>
                </aum-select>
                <div class="click-cell-button" *ngIf="activeField === fieldsEnum.accountName">
                    <button aum-icon-button color="accent" icon="lighting-light-bulb">
                        {{ 'aumico_annual_report_import_definition_click_cell' | i18next }}
                    </button>
                </div>
            </div>
            <div
                class="field"
                [ngClass]="{ 'active-field': activeField === fieldsEnum.balance }"
                #balance
                (click)="setActiveField(fieldsEnum.balance)"
                *ngIf="!accountNameFirstTime && showForm"
            >
                <aum-select
                    placeholder="{{ 'aumico_annual_report_import_please_select' | i18next }}"
                    [aumFormControl]="form.controls['balanceColNo']"
                    [options]="columnOptions"
                >
                    <aum-form-field-label
                        >{{ 'aumico_annual_report_import_indicate_balance_column' | i18next }}
                    </aum-form-field-label>
                </aum-select>
                <div class="click-cell-button" *ngIf="activeField === fieldsEnum.balance">
                    <button aum-icon-button color="accent" icon="lighting-light-bulb">
                        {{ 'aumico_annual_report_import_definition_click_cell' | i18next }}
                    </button>
                </div>
            </div>
            <div
                class="field"
                [ngClass]="{ 'active-field': activeField === fieldsEnum.previousYear }"
                #previousYear
                (click)="setActiveField(fieldsEnum.previousYear)"
                *ngIf="!balanceFirstTime && showForm && showPreviousYearField"
            >
                <aum-select
                    placeholder="{{ 'aumico_annual_report_import_please_select' | i18next }}"
                    [aumFormControl]="form.controls['previousYearColNo']"
                    [options]="columnOptions"
                >
                    <aum-form-field-label
                        >{{ 'aumico_annual_report_import_indicate_previous_year_column' | i18next }}
                    </aum-form-field-label>
                </aum-select>
                <div class="click-cell-button" *ngIf="activeField === fieldsEnum.previousYear">
                    <button aum-icon-button color="accent" icon="lighting-light-bulb">
                        {{ 'aumico_annual_report_import_definition_click_cell' | i18next }}
                    </button>
                </div>
            </div>
            <div
                class="field"
                [ngClass]="{ 'active-field': activeField === fieldsEnum.shareholder }"
                #shareholder
                (click)="setActiveField(fieldsEnum.shareholder)"
                *ngIf="showShareholderField && !balanceFirstTime && showForm"
            >
                <aum-select
                    placeholder="{{ 'aumico_annual_report_import_please_select' | i18next }}"
                    [aumFormControl]="form.controls['shareholderColNo']"
                    [options]="columnOptions"
                >
                    <aum-form-field-label
                        >{{ 'aumico_annual_report_import_indicate_shareholder_column' | i18next }}
                    </aum-form-field-label>
                </aum-select>
                <div class="click-cell-button" *ngIf="activeField === fieldsEnum.shareholder">
                    <button aum-icon-button color="accent" icon="lighting-light-bulb">
                        {{ 'aumico_annual_report_import_definition_click_cell' | i18next }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
